import ResizeController from '../../../assets/js/controllers/resize';

// import { mq } from '../../assets/js/helpers';

export default class MapEvents {

	static selector = 'map-events';

	// class variables

	controllers = {
		resize: null
	};

	el = {};

	// constructor

	constructor(container) {
		this.el = {
			container
		};

		this.initialize();
	}

	// initialize

	initialize() {
		this.#addEventListeners();
	}

	// add / remove event listeners

	#addEventListeners = () => {
		this.controllers.resize = ResizeController.set({
			update: this.#onResizeUpdate,
			render: this.#onResizeRender
		});
	}

	#removeEventListeners = () => {
		ResizeController.clear(this.controllers.resize);
	}

	// listener methods

	#onResizeUpdate = () => true;

	#onResizeRender = () => {

	}

	//

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}

/*
[
    {
        "featureType": "administrative",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "saturation": -100
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            },
            {
                "saturation": -60
            },
            {
                "lightness": 10
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            },
            {
                "saturation": "-100"
            },
            {
                "lightness": "100"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            },
            {
                "saturation": -100
            },
            {
                "lightness": 60
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "saturation": -100
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            },
            {
                "saturation": -100
            },
            {
                "lightness": 60
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "saturation": "-40"
            },
            {
                "lightness": 30
            }
        ]
    }
]

*/
